





























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class BusquedaConFiltros extends Vue {
  @Prop()
  private filtro
  @Prop({ type: String, default: 'Búsqueda' })
  private titulo: string
  @Prop({ type: Boolean, default: true })
  private showBusqueda: boolean
  @Prop()
  private test!: any
  @Prop({ type: Boolean, default: false })
  private loading = false

  $refs: {
    buscar: Vue & { $el: HTMLElement }
  }
  mounted() {
    this.$nextTick(() => this.$refs.buscar.$el.focus())
  }
  buscar(val) {
    this.$emit('buscar', val)
  }

  limpiar() {
    this.$emit('limpiar')
  }
}
